import View from './View'
import { updateSpriteSheet } from './helpers/DOMHelper'
import { ease } from './helpers/EaseHelper'
/**
 * class Overlay
 */

const COUNT_FRAME_BG_MAX = 35
const DELAY_BRUSH = 4200
const DURATION_BRUSH = 1000
const DELAY_HIDE = 1000
const BG_OPACITY = 0.4

class Overlay extends View {
  /**
   * constructor
   */
  constructor (el, onStateChange = () => {}) {
    super(el, onStateChange)
  }

  fadeIn () {
    ease({ opacity: BG_OPACITY })
      .to({ opacity: 0 }, 1000)
      .delay(1000)
      .onUpdate(props => {
        this.view.style.backgroundColor = `rgba(0, 0, 0, ${props.opacity})`
      })
      .start()
  }

  fadeOut () {
    ease({ opacity: 0 })
      .to({ opacity: BG_OPACITY }, 1000)
      .onUpdate(props => {
        this.view.style.backgroundColor = `rgba(0, 0, 0, ${props.opacity})`
      })
      .start()
  }

  showHandler (resolve) {
    updateSpriteSheet(this.view, '100%', 0)
    this.view.style.opacity = 1
    resolve()
  }

  hideHandler (resolve) {
    const onBrushComplete = () => {
      ease({ opacity: 1 })
        .delay(DELAY_HIDE)
        .to({ opacity: 0 }, 1000)
        .onUpdate(props => {
          this.view.style.opacity = props.opacity
        })
        .onComplete(() => resolve())
        .start()
    }
    ease({ framecount: 0 })
      .delay(DELAY_BRUSH)
      .to({ framecount: COUNT_FRAME_BG_MAX - 1 }, DURATION_BRUSH)
      .onUpdate(o => {
        updateSpriteSheet(this.view, '100%', o.framecount)
      })
      .onComplete(onBrushComplete)
      .start()
  }
}
export default Overlay


// WEBPACK FOOTER //
// ./src/scripts/Overlay.js